import React from "react"
import { useTranslation } from "react-i18next"

import { AttachFileField } from "~/components/AttachFile/AttachFile"
import { Button } from "~/components/Button/Button"
import { Form } from "~/components/Form/Form"
import { FormSubmitSection } from "~/components/FormSubmitSection/FormSubmitSection"
import { Heading } from "~/components/Heading/Heading"
import { FormInput } from "~/components/Input/Input"
import { PopupWrapper } from "~/components/Popup/Popup"
import { RadioBundle } from "~/components/RadioBundle/RadioBundle"
import { Raw } from "~/components/raw"
import { FormTextArea } from "~/components/TextArea/TextArea"

import styles from "./index.module.css"

const Content: React.FC = () => {
  const { t } = useTranslation()

  return (
    <>
      <Heading className={styles.Title} like="h3">
        <Raw html={t("conflictCommission.Popup.Title")} />
      </Heading>

      <div className={styles.Description}>
        <p>
          <Raw html={t("conflictCommission.Popup.Description")} />
        </p>
      </div>

      <Form
        className={styles.Form}
        initialValues={{
          phone: "",
          email: "",
          name: "",
          message: "",
          organisation: "organisation",
        }}
        url="/conflictform/submit"
        isFileRequired
      >
        <FormInput label={t("popup.Default.Form.Phone.Label")} name="phone" />
        <FormInput label={t("popup.Default.Form.Email.Label")} name="email" />
        <FormInput label={t("popup.Default.Form.Fio.Label")} name="name" />

        <RadioBundle />

        <FormTextArea label={t("popup.Default.Form.Message.Label")} name="message" />

        <AttachFileField onlyPdf />

        <FormSubmitSection className={styles.SendWrapper} />
      </Form>
    </>
  )
}

export const SendTreatment: React.FC = () => {
  const { t } = useTranslation()
  return (
    <PopupWrapper
      button={
        <Button view="xl">
          <Raw html={t("conflictCommission.TreatmentOrder.Button")} />
        </Button>
      }
      content={() => <Content />}
    />
  )
}
